import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input, output, signal } from '@angular/core';

import { CreateAppointmentService } from '@hm/core/services/create-appointment.service';

import { AppointmentSuggestionResponse } from '@lib/core/models/create-appointment.interface';

import { WarningMessageComponent } from '@lib/shared-ui/commons/warning-message/warning-message.component';
import { LoaderComponent } from '@lib/shared-ui/layout/loader/loader.component';

import { SuggestionItemComponent } from './suggestion-item/suggestion-item.component';

@Component({
  selector: 'hm-suggestions-list',
  imports: [SuggestionItemComponent, LoaderComponent, WarningMessageComponent, NgClass],
  templateUrl: './suggestions-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestionsListComponent implements OnInit {
  private readonly appointmentService = inject(CreateAppointmentService);

  userId = input.required<string>();
  partnerId = input.required<string>();

  protected readonly loading = signal<boolean>(false);
  protected readonly suggestions = signal<AppointmentSuggestionResponse[]>([]);
  protected readonly selectedSuggestion = signal<AppointmentSuggestionResponse | null>(null);
  protected readonly suggestionsWarning = signal<string | null>(null);

  suggestionSelected = output<AppointmentSuggestionResponse>();

  ngOnInit() {
    this.fetchSuggestions();
  }

  protected fetchSuggestions() {
    this.loading.set(true);
    this.suggestionsWarning.set(null);

    return this.appointmentService.getAppointmentSuggestions(this.userId(), this.partnerId()).subscribe({
      next: result => {
        this.suggestions.set(result);
        if (!result.length) this.suggestionsWarning.set('Візити для цього партнера відсутні');
        this.loading.set(false);
      },
      error: () => {
        this.suggestions.set([]);
        this.suggestionsWarning.set('Не вдалось отримати візити партнера');
        this.loading.set(false);
      },
    });
  }

  protected selectSuggestion(suggestion: AppointmentSuggestionResponse) {
    if (this.selectedSuggestion() === suggestion) this.selectedSuggestion.set(null);
    else {
      this.selectedSuggestion.set(suggestion);
      this.suggestionSelected.emit(suggestion);
    }
  }

  protected isSuggestionSelected(suggestion: AppointmentSuggestionResponse): boolean {
    return this.selectedSuggestion() === suggestion;
  }
}
